'use strict'

module.exports = {
  PROTOCOL: '/ipfs/ping/1.0.0',
  PING_LENGTH: 32
}



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-ping/src/constants.js
// module id = 144
// module chunks = 0